import { Button } from '@/components/elements/Button'

export interface ContactCTAProps {
  title: string
  subtitle: string
  ctaUrl?: string
  ctaLabel?: string
}

export const ContactCTA: React.FC<ContactCTAProps> = ({
  title,
  subtitle,
  ctaUrl,
  ctaLabel,
}) => {
  return (
    <section className="contact-shadow mx-auto p-7 max-w-lg text-left rounded">
      <h3 className="mb-4 font-body text-lg font-semibold">{title}</h3>
      <div className="flex flex-col items-start mt-4">
        <p className="font-body font-normal leading-tight">{subtitle}</p>
        {ctaLabel && ctaUrl && (
          <div className="flex-shrink-0 mt-8">
            <Button href={ctaUrl} label={ctaLabel} variant="outlined" />
          </div>
        )}
      </div>
    </section>
  )
}
